// Auto-generated normalizer for table: AreaNegocio
export function areaNegocioNormalize(row) {
  return {
    idAreaNegocio: row.idAreaNegocio ?? row.IdAreaNegocio ?? row['IdAreaNegocio'] ?? 0,
    clave: row.clave ?? row.Clave ?? row['Clave'] ?? '',
    nombre: row.nombre ?? row.Nombre ?? row['Nombre'] ?? '',
    descripcion: row.descripcion ?? row.Descripcion ?? row['Descripcion'] ?? '',
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
    fechaCreacion: row.fechaCreacion ?? row.FechaCreacion ?? row['FechaCreacion'] ?? null,
  };
}
